/**
 * Widget: AutoComplete
 * Component: AutoCompleteField.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu, Moises Trullàs, Xevi Naval
 * Versió: 2.0
 * Data: 25/10/2017
 * (c) Ajuntament de Manresa - jun 2019 - Departament de Sistemes d'Informació
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import deburr from 'lodash/deburr';
import AutoComplete from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, makeStyles, createMuiTheme } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import { useState, useEffect } from "react";
import { InputAdornment } from "@material-ui/core"; // Styles

var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      // height: 250,
      flexGrow: 1,
      position: 'relative'
    },
    container: {
      position: 'relative'
    },
    input: {
      marginLeft: -5,
      marginRight: -5
    },
    adornedStart: {
      paddingLeft: 5
    },
    adornedEnd: {
      paddingRight: 5
    },
    inputAdornment: {
      opacity: 0.50
    },
    button: {
      padding: 5
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 9,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0
    },
    suggestion: {
      display: 'block'
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    },
    divider: {
      height: theme.spacing(2)
    }
  });
});
var defaultProps = {
  highlightSuggestion: true,
  takeFirstWhenNoValue: true,
  waitForEndRequestOnBlur: true,
  showValueOnSuggestionDisplay: 'none'
}; // Component

var AjtAutoCompleteRender = function AjtAutoCompleteRender(props, referencia) {
  // region code
  props = __assign(__assign({}, defaultProps), props); // Private Methods
  // Retorna una fila del datasoure a partir de la clau

  var getSuggestion = function getSuggestion(value) {
    return props.dataSource.find(function (item) {
      return item[props.valueField] === value;
    });
  }; // Retorna el valor a mostrar a partir d'una suggestió


  var getSuggestionDisplay = function getSuggestionDisplay(suggestion) {
    var suggestionDisplay = '';

    if (suggestion) {
      if (props.showValueOnSuggestionDisplay === 'first') {
        suggestionDisplay += '(' + suggestion[props.valueField] + ') ';
      }

      suggestionDisplay += suggestion[props.displayField];

      if (props.showValueOnSuggestionDisplay === 'last') {
        suggestionDisplay += ' (' + suggestion[props.valueField] + ')';
      }
    }

    return suggestionDisplay;
  }; // Retorna el valor a mostrar a partir d'una suggestió


  var getSuggestionValue = function getSuggestionValue(suggestion) {
    if (suggestion) {
      return suggestion[props.valueField];
    }

    return null;
  }; // Classes Style


  var classes = useStyles(createMuiTheme());
  var isDense = props.margin === 'dense'; // States

  var initialSuggestion = getSuggestion(props.value);

  var _a = useState(getSuggestionDisplay(initialSuggestion)),
      searchValue = _a[0],
      setSearchValue = _a[1];

  var _b = useState(props.dataSource),
      suggestions = _b[0],
      setSuggestions = _b[1];

  var _c = useState(initialSuggestion),
      selectedSuggestion = _c[0],
      setSelectedSuggestion = _c[1];

  var _d = useState(undefined),
      requestInProgress = _d[0],
      setRequestInProgress = _d[1];

  useEffect(function () {
    var actualValue = getSuggestionValue(selectedSuggestion);
    var suggestion = getSuggestion(props.value); // Si el valor que ens han canviat el trobem en la llista

    if (!!suggestion) {
      // Carreguem les dades al control
      setSearchValue(getSuggestionDisplay(suggestion));
      setSelectedSuggestion(suggestion);
    } else {
      // Si no el treobem
      // Tenim valor (actualValue) envara triat, i el nou és buit
      if (!props.value && !!actualValue) {
        // Esborrem les dades del control
        setSearchValue('');
        setSelectedSuggestion(undefined);
      }
    }
  }, [props.value, props.dataSource]); // let inputTextField;
  // Per detectar quan es fa 'Suprimir', que si cal envi l'event del onChanged

  var handleKeyUp = function handleKeyUp(event) {
    if (event.keyCode == 8 || event.keyCode === 46) {
      throwOnChange();
    }
  }; // MULTIPLIER
  // if (props.InputProps?.inputProps?.style?.fontSize) {
  //     const fontSize = props.InputProps.inputProps.style.fontSize;
  //     if (typeof fontSize === "string" && fontSize.slice(-1) === '%') {
  //         const multiplier = parseInt(fontSize.slice(0, -1)) / 100;
  //         const padding = (props.margin === "dense" ? 10.5 : 18.5) * multiplier;
  //         props.InputProps.inputProps.style = {paddingTop: padding, paddingBottom: padding, ...props.InputProps.inputProps.style};
  //     }
  // }


  var myNode;

  var renderInputComponent = function renderInputComponent(inputProps) {
    var classes = inputProps.classes,
        _a = inputProps.inputRef,
        _inputRef = _a === void 0 ? function () {} : _a,
        ref = inputProps.ref,
        other = __rest(inputProps, ["classes", "inputRef", "ref"]);

    var variant = {
      variant: props.variant || 'standard'
    };
    var isStandard = props.variant === 'standard';
    var margin = props.margin || 'normal';
    var textFieldClasses = Object.assign(isDense ? {
      input: classes.input
    } : {}, isDense && !isStandard ? {
      adornedStart: classes.adornedStart
    } : {}, isDense && !isStandard && (props.showClear && !!searchValue || props.actionButton) ? {
      adornedEnd: classes.adornedEnd
    } : {});
    return React.createElement(TextField, __assign({
      fullWidth: true,
      InputProps: __assign(__assign({}, props.InputProps), {
        inputRef: function inputRef(node) {
          ref(node);

          _inputRef(node); // inputTextField = node;


          if (typeof referencia === 'object' && referencia !== null) {
            referencia.current = node;
          }

          myNode = node;
        },
        classes: textFieldClasses,
        startAdornment: React.createElement(InputAdornment, {
          position: "start",
          className: classes.inputAdornment
        }, React.createElement(IconButton, {
          disableFocusRipple: true,
          onClick: handleSearchButton,
          className: isDense ? classes.button : ''
        }, React.createElement(SearchIcon, null))),
        endAdornment: React.createElement(InputAdornment, {
          position: "end",
          className: classes.inputAdornment
        }, props.showClear && !!searchValue && React.createElement(IconButton, {
          key: "clear",
          "aria-label": "Esborrar",
          onClick: handleClear,
          disableFocusRipple: true,
          className: isDense ? classes.button : ''
        }, React.createElement(ClearIcon, null)), props.actionButton)
      }),
      InputLabelProps: props.InputLabelProps,
      onKeyUp: handleKeyUp,
      margin: margin
    }, variant, other));
  };

  var renderSuggestion = function renderSuggestion(suggestion, _a) {
    var query = _a.query,
        isHighlighted = _a.isHighlighted;
    var parts = [];

    if (props.highlightSuggestion) {
      var matches = match(suggestion[props.displayField], query);
      parts = parse(suggestion[props.displayField], matches);
    } else {
      parts = [{
        text: suggestion[props.displayField]
      }];
    }

    return React.createElement(MenuItem, {
      selected: isHighlighted,
      component: "div"
    }, React.createElement("span", null, parts.map(function (part, index) {
      return React.createElement("span", {
        key: index,
        style: {
          fontWeight: part.highlight ? 600 : 400
        }
      }, part.text);
    })));
  };

  var getSuggestions = function getSuggestions(input) {
    // console.log('input', input);
    var inputValue = deburr(input.trim()).toLowerCase();
    var inputLength = inputValue.length;
    var maxCount = 8;
    var count = 0;
    return inputLength === 0 ? [] : props.dataSource.filter(function (suggestion) {
      var keep = count < maxCount && match(suggestion[props.displayField], inputValue).length > 0;

      if (keep) {
        count += 1;
      }

      return keep;
    });
  };

  var throwOnChange = function throwOnChange(suggestion) {
    if (!suggestion && !!selectedSuggestion || !!suggestion && !selectedSuggestion || !!suggestion && !!selectedSuggestion && suggestion !== selectedSuggestion) {
      setSelectedSuggestion(suggestion);

      if (props.onChange) {
        props.onChange(suggestion);
      }
    }
  };

  var handleSuggestionSelected = function handleSuggestionSelected(event, _a) {
    var suggestion = _a.suggestion,
        suggestionValue = _a.suggestionValue,
        suggestionIndex = _a.suggestionIndex,
        sectionIndex = _a.sectionIndex,
        method = _a.method;
    throwOnChange(suggestion);
  }; // Posem el focus al field


  var handleSearchButton = function handleSearchButton() {
    myNode.focus();
  }; // Netegem el contingut


  var handleClear = function handleClear() {
    // console.log('Clear');
    setSearchValue('');
    handleSuggestionsClearRequested();
    throwOnChange(); // !!inputTextField && inputTextField.focus();
  }; // Al sortir


  var handleBlur = function handleBlur() {
    // Si al sortir no tenim valor
    if (!selectedSuggestion) {
      if (props.waitForEndRequestOnBlur && requestInProgress) {
        requestInProgress.then(function (results) {
          var suggestion = '';
          var suggestionDisplay = '';

          if (results.length === 1) {
            suggestion = results[0];
            suggestionDisplay = getSuggestionDisplay(suggestion);
          } else {
            results.map(function (result, index) {
              if (result[props.valueField] && (result[props.valueField] === searchValue || typeof result[props.valueField] === 'string' && result[props.valueField].toUpperCase() === searchValue.toUpperCase())) {
                suggestion = results[index];
                suggestionDisplay = getSuggestionDisplay(suggestion);
              }
            });
          }

          setSearchValue(suggestionDisplay);
          throwOnChange(suggestion);
        });
      } else {
        // Calculem la llista segons el text entrat
        var suggestions_1 = ajtAutoCompleteProps.suggestions; // Si té mes d'una suggestion + takeFirstWhenNoValue o si en té només una suggestion => agafem la primera

        if (suggestions_1.length === 1 && getSuggestionDisplay(suggestions_1[0]).trim().length === searchValue.trim().length || suggestions_1.length >= 1 && props.takeFirstWhenNoValue) {
          var suggestion = suggestions_1[0];
          setSearchValue(getSuggestionDisplay(suggestion));
          throwOnChange(suggestion); // Si no netejem el camp
        } else {
          setSearchValue('');
          throwOnChange();
        }
      }
    }
  };

  var handleSuggestionsFetchRequested = function handleSuggestionsFetchRequested(_a) {
    var _b;

    var value = _a.value,
        reason = _a.reason; // console.log("handleSuggestionsFetchRequested", value, reason);

    if (reason === 'input-changed') {
      throwOnChange();
    }

    if (!!props.onSuggestionsFetchRequested) {
      props.onSuggestionsFetchRequested({
        value: value,
        reason: reason
      });
    } else if (!!props.fetchSuggestions) {
      setRequestInProgress((_b = props.fetchSuggestions(value)) === null || _b === void 0 ? void 0 : _b.then(function (result) {
        if (result) {
          setRequestInProgress(undefined);
        }

        return result;
      }));
    } else {
      setSuggestions(getSuggestions(value));
    }
  };

  var handleSuggestionsClearRequested = props.onSuggestionsClearRequested || function () {
    // console.log("handleSuggestionsClearRequested");
    setSuggestions([]);
  }; // Props to Render


  var ajtAutoCompleteProps = {
    renderInputComponent: renderInputComponent,
    suggestions: !!props.onSuggestionsFetchRequested || !!props.fetchSuggestions ? props.dataSource : suggestions,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    onSuggestionSelected: handleSuggestionSelected,
    getSuggestionValue: getSuggestionDisplay,
    renderSuggestion: !!props.renderSuggestion ? props.renderSuggestion : renderSuggestion
  }; // Render

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(AutoComplete, __assign({}, ajtAutoCompleteProps, {
    inputProps: {
      classes: classes,
      label: props.label,
      placeholder: props.placeholder,
      value: searchValue,
      error: props.error,
      helperText: props.helperText,
      required: props.required,
      onBlur: function onBlur(event, params) {
        handleBlur();
      },
      onChange: function onChange(event, params) {
        setSearchValue(params.newValue);
      }
    },
    theme: {
      container: classes.container,
      suggestionsContainerOpen: classes.suggestionsContainerOpen,
      suggestionsList: classes.suggestionsList,
      suggestion: classes.suggestion
    },
    renderSuggestionsContainer: function renderSuggestionsContainer(options) {
      return React.createElement(Paper, __assign({}, options.containerProps, {
        square: true
      }), options.children);
    }
  }))); // endregion code
};

var AjtAutoComplete = React.forwardRef(AjtAutoCompleteRender);
export default AjtAutoComplete;